export default {
    popularTags: 'Popular Tags',
}
